import React, { useState, useEffect } from "react";

import { Form, Input, Select, Button, Upload, message } from "antd";
export default function InvestApplyStepOne({
  onFinish,
  initialValues,
  loadingTicket,
  setLoadingTicket,
  onNext,
  userDetails,
}) {
  const [form] = Form.useForm();

  const next = () => {
    onNext?.();
  };
  return (
    <>
      {" "}
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: initialValues?.name,
          surname: initialValues?.surname,
          phone: initialValues?.cellphone,
          email: initialValues?.email,
        }}
        onFinish={onFinish}
        className=""
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the subject" }]}
        >
          <Input className="h-12 rounded-xl" />
        </Form.Item>
        <Form.Item
          label="Surname"
          name="surname"
          rules={[{ required: true, message: "Please enter the subject" }]}
        >
          <Input className="h-12 rounded-xl" />
        </Form.Item>
        <Form.Item
          label="Cellphone"
          name="phone"
          rules={[{ required: true, message: "Please enter the subject" }]}
        >
          <Input className="h-12 rounded-xl" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter the subject" }]}
        >
          <Input className="h-12 rounded-xl" />
        </Form.Item>
        <Form.Item>
          <button
            type="primary"
            onClick={next}
            className="px-32 py-3 mt-5 bg-gradient-to-r flex justify-self-center from-purple-500 to-rose-600 text-white py-3 rounded-full text-sm font-medium"
          >
            Next
          </button>
        </Form.Item>
      </Form>
    </>
  );
}
